export default __webpack_public_path__ + "static/media/photo8.469e9bda.jpg";